import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSavePlumbingScheduleScriptForm } from '../api/save-plumbingScheduleScriptForm';

const PlumbingScheduleScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {

    const initialFormState = {
        customerNameText: '',
        reconnectItemsQtyText: '',
        reconnectSinkQtyText: '',
        reconnectFaucetQtyText: '',
        reconnectDishwasherQtyText: '',
        reconnectGarbageDisposalQtyText: '',
        reconnectWaterFiltrationText: '',
        reconnectOtherText: '',
        scheduledDisconnectDateText: '',
        aDecisionMakerCheckbox: false,
        availableDisconnectDateText: '',
        availableReconnectDateText: '',
        beforeOurPlumberArrivesCheckbox: false,
        countertopDateText: '',
        customerNameTextbox: '',
        dateAndTimeTextbox: '',
        emailTextbox: '',
        introductionCheckbox: false,
        reiterateContactCheckbox: false,
        scheduleDisconnectCheckbox: false,
        notesTextbox: '',
        scheduleReconnectCheckbox: false,
        phoneNumberTextbox: '',
        pleaseContactUsImmediatelyCheckbox: false,
        scheduledReconnectDateText: '',
        closingCheckbox: false
    };

    const [formState, setFormState] = useState(initialFormState);

    const savePlumbingScheduleScriptForm = useSavePlumbingScheduleScriptForm(
        {
            formObject: {
                retailOrderID,
                retailOrderNo: retailOrderNumber,
                ...formState
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFormState(initialFormState);
    };

    return (
        <div>
            <div className='main-header' style={{ height:'90px'}}>
                <h1>
                    <div>Plumbing Call Script</div>
                    <div>Plumber Schedule Disconnect/Reconnect Appointment</div>
                </h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Introduction:</span></div>
                <div className='section-row'>
                    <label>
                    <span >
                    <input type="CheckBox"
                        checked={formState.introductionCheckbox} onChange={(e) => setFormState({ ...formState, introductionCheckbox: e.target.checked })} />
                        </span>
                    <span className='standard-margin-left-distance'>
                        Hello Mr/Mrs </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="customerNameText"
                                value={formState.customerNameText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>, I’m [name] with [company name], your plumbing provider. How are you today? 
                            I’m calling to schedule your plumbing appointment related to your countertop project.
                    </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Schedule Disconnect Appointment:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.scheduleDisconnectCheckbox} onChange={(e) => setFormState({ ...formState, scheduleDisconnectCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            Let’s schedule your disconnect appointment. This service is where we shut off and
                            remove your existing plumbing connections so your countertop installer can proceed with installation.
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            It looks like your countertop installation is scheduled for
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="countertopDateText"
                                value={formState.countertopDateText}
                                onChange={handleTextInputChange}
                            />
                        </span>.
                        <span className='standard-margin-left-distance'>
                            We have availability on
                        </span>
                        <span>
                            <input
                                type="text"
                                name="availableDisconnectDateText"
                                value={formState.availableDisconnectDateText}
                                onChange={handleTextInputChange}
                            />
                        </span>.
                        <span className='standard-margin-left-distance'>
                            Does that work for you?
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance italic-text'>
                            (if not, discuss options and explain they will not be able to use areas until at least 24hrs after countertop installation)
                        </span>
                        </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance bold-text'>
                            Scheduled Disconnect Date & Time:
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="scheduledDisconnectDateText"
                                value={formState.scheduledDisconnectDateText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Schedule Reconnect Appointment:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.scheduleReconnectCheckbox} onChange={(e) => setFormState({ ...formState, scheduleReconnectCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            For your reconnect service, this is where we will hook up your plumbing to your new
                            sinks, faucets, and any other areas needed after your countertops are installed, how
                            many items will be needed for plumbing reconnect?
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectItemsQtyText"
                                value={formState.reconnectItemsQtyText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            "How many new sinks and faucets do you have where your countertops will be installed?"
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            Sinks:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectSinkQtyText"
                                value={formState.reconnectSinkQtyText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            Faucets:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectFaucetQtyText"
                                value={formState.reconnectFaucetQtyText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            "Do you have a dishwasher, garbage disposal, water filtration system, etc. where your countertops will be installed?"
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            Dishwasher:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectDishwasherQtyText"
                                value={formState.reconnectDishwasherQtyText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            Garbage Disposal:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectGarbageDisposalQtyText"
                                value={formState.reconnectGarbageDisposalQtyText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            Water Filtration:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectWaterFiltrationText"
                                value={formState.reconnectWaterFiltrationText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            Other:
                        </span>
                        <span>
                            <input
                                type="text"
                                name="reconnectOtherText"
                                value={formState.reconnectOtherText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance'>
                            "Thank you for providing this information. Let’s schedule your reconnect
                            appointment. We have availability on </span>
                        <span>
                            <input
                                type="text"
                                name="availableReconnectDateText"
                                value={formState.availableReconnectDateText}
                                onChange={handleTextInputChange}
                            />
                        </span>.
                        <span className='standard-margin-left-distance'>
                            Does that work for you?"
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance italic-text'>
                            (if not, discuss options and explain they will not be able to use areas until the reconnect is completed)
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <span className='standard-margin-left-distance bold-text'>
                            Scheduled Reconnect Date & Time:
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="scheduledReconnectDateText"
                                value={formState.scheduledReconnectDateText}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Discuss Preparation:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.beforeOurPlumberArrivesCheckbox} onChange={(e) => setFormState({ ...formState, beforeOurPlumberArrivesCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Before our plumber arrives, please ensure the area is clear of any personal items or
                            furniture to make the process smoother.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.aDecisionMakerCheckbox} onChange={(e) => setFormState({ ...formState, aDecisionMakerCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “A decision maker 18 years or older, must be present for the duration of both the
                            disconnect and reconnect appointment.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.pleaseContactUsImmediatelyCheckbox} onChange={(e) => setFormState({ ...formState, pleaseContactUsImmediatelyCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Please contact us immediately, at least 24 hours prior to your scheduled
                            appointments if you need to reschedule.”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Reiterate Contact Information:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.reiterateContactCheckbox} onChange={(e) => setFormState({ ...formState, reiterateContactCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “If you have any questions before either appointment, feel free to reach out. You may
                            contact us at (phone number)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="phoneNumberTextbox"
                                value={formState.phoneNumberTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            or (email)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="emailTextbox"
                                value={formState.emailTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.closingCheckbox} onChange={(e) => setFormState({ ...formState, closingCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Thank you for your time, (customer’s name)
                        </span>
                        <span>
                            <input
                                type="text"
                                name="customerNameTextbox"
                                value={formState.customerNameTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            We look forward to meeting you on (confirm date & time)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="dateAndTimeTextbox"
                                value={formState.dateAndTimeTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            Have a great day!
                        </span>
                    </label>

                    
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={formState.notesTextbox}
                        onChange={handleTextInputChange}
                        placeholder="Note"
                        name='notesTextbox'
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        savePlumbingScheduleScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default PlumbingScheduleScriptForm;
